var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _c(
        "v-row",
        { staticClass: "pa-4", attrs: { justify: "space-between" } },
        [
          _c(
            "v-col",
            { attrs: { md: "3", cols: "12" } },
            [
              _c("v-card-text", [_vm._v(" Parent Profile ")]),
              _c("v-treeview", {
                attrs: {
                  items: _vm.root_tree,
                  active: _vm.active,
                  hoverable: "",
                  dense: "",
                  activatable: "",
                  color: "info",
                  "selection-type": "independent",
                  transition: "",
                },
                on: { "update:active": _vm.setActive },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function ({}) {
                      return [_c("v-icon", [_vm._v("mdi-note")])]
                    },
                  },
                ]),
              }),
              _vm.children.length > 0
                ? _c(
                    "div",
                    [
                      _c("v-card-text", [
                        _vm._v(" Depends On These Profiles: "),
                      ]),
                      _c("v-treeview", {
                        attrs: {
                          items: _vm.children,
                          active: _vm.active,
                          hoverable: "",
                          dense: "",
                          activatable: "",
                          color: "info",
                          "selection-type": "independent",
                          transition: "",
                        },
                        on: { "update:active": _vm.setActive },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prepend",
                              fn: function ({}) {
                                return [_c("v-icon", [_vm._v("mdi-note")])]
                              },
                            },
                          ],
                          null,
                          false,
                          2199412629
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-col",
            { staticClass: "text-center" },
            [_c("ProfileInfo", { attrs: { profile: _vm.selected } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }